import { render } from "./WindowShadowRender.vue?vue&type=template&id=97242b58&scoped=true"
import script from "./WindowShadowRender.vue?vue&type=script&lang=js"
export * from "./WindowShadowRender.vue?vue&type=script&lang=js"

import "./WindowShadowRender.vue?vue&type=style&index=0&id=97242b58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97242b58"]])

export default __exports__